import DateUtil from "@/util/DateUtil.js";

const list = {
  components() {
    return [
      {
        component: "search-year",
        label: "연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
          labelHiddenResolution: "xl",
        },
      },
      {
        component: "search-year-quarter",
        label: "분기",
        value: "quarter",
        query: { y_q: "quarter" },
        options: {
          default: "",
          afterFix: "분기",
          onlyNum: true,
          labelHiddenResolution: "xl",
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["실시구분", "사업장명", "회의일자", "작성일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({ key: "header.year", operator: "=", value: search.year });
    }
    // 분기
    if (search.quarter) {
      conditions.push({ key: "header.quarter", operator: "=", value: search.quarter });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  getHead: () => {
    return [
      {
        name: "실시구분",
        key: "header.quarter",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "구분",
        key: "body.구분",
      },
      {
        name: "회의일자",
        key: "body.subInfo.회의일자",
      },
      {
        name: "논의·심의·의결 내용",
        key: "body.subInfo.논의심의의결내용",
      },
      {
        name: "종사자 의견",
        key: "body.subInfo.종사자의견",
      },
      {
        name: "조치계획",
        key: "body.subInfo.조치계획",
      },
      {
        name: "소속1",
        key: "body.stdInfo.section",
      },
      {
        name: "소속2",
        key: "body.stdInfo.department",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
      case 0:
        return `${postContent.header.quarter}분기`; // 실시구분 (분기)
      case 1:
        return func.getContent(value).stdInfo.field_name; // 사업장명
      case 2:
        return func.getContent(value).구분; // 구분
      case 3:
        return func.getContent(value).subInfo.회의일자; // 회의일자
      case 4:
        return func.getContent(value).subInfo.논의심의의결내용; // 논의·심의·의결 내용
      case 5:
        return func.getContent(value).subInfo.종사자의견; // 종사자 의견
      case 6:
        return func.getContent(value).subInfo.조치계획; // 조치계획
      case 7:
        return func.getContent(value).stdInfo.section; // 부서명
      case 8:
        return func.getContent(value).stdInfo.department; // 소속명
      case 9:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      case 10:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (/*nav*/) => {},
  getSearchKeyword: (/*nav*/) => {},
};
export default list;
